import { useEffect, useState } from 'react'
import { useAppSelector } from '../../../../hooks/useStore'
import { checkPassportStatus } from '../../../../actions/userActions'
import { platformStoreGet } from '../../../../../../shared/helpers'

export const PENDING_PASSPORT = 'PENDING'
export const ACTIVATED_PASSPORT = 'ACTIVATED'

const useCheckPassportStatus = (enabled: boolean = true) => {
  const [loadingPassportStatus, setLoadingPassportStatus] = useState(false)
  const [passportStatus, setPassportStatus] = useState('')
  const station = useAppSelector((state) => state.station)
  const unactivatedPassport = platformStoreGet('mvault_id')
  const fetchPassportStatus = async () => {
    try {
      setLoadingPassportStatus(true)
      const responseStatus = await checkPassportStatus(station.call_sign)
      setPassportStatus(responseStatus)
    } catch (error) {
      console.error('Error fetching passport status:', error)
      setPassportStatus('')
    } finally {
      setLoadingPassportStatus(false)
    }
  }

  useEffect(() => {
    if (enabled && unactivatedPassport) {
      fetchPassportStatus()
    }
  }, [station.call_sign, enabled])

  return {
    loadingPassportStatus,
    passportStatus,
  }
}

export default useCheckPassportStatus
